// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2Lv6j","header":"PatientBlock_header__mQnfD","label":"PatientBlock_label__3-BW-","option":"PatientBlock_option__2uDWD"};